module.exports = __webpack_public_path__ + "a3090b1e5672f9d2cd8aeb105233527f.svg";